import locationServices from '../../services/location';
import Location from '../../model/location';

export const state = {
    locations: [],
}

export const mutations = {
    setLocations(state, locations) {
        state.locations = locations
    }
}

export const getters = {
    getLocations(state) {
        return state.locations.map((p)=>new Location(p))
    },
}

export const actions = {
    getAll({commit}, data = {}){
        return locationServices.getAll(data)
        .then((response)=>{
            commit('setLocations', response.data.data)
            return response
        })
    },
}